namespace GeniuzPOS.Lookups {
    export namespace LookupPostranHdService {
        export const baseUrl = 'Lookups/LookupPostranHd';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LookupPostranHdRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Lookups/LookupPostranHd/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>LookupPostranHdService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
